import styled from 'styled-components'

export const Container = styled.div`
  display: block;
  height: 100vh;
  position: relative;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  align-items: center;

  .wave{
    position: absolute;
    z-index: -1;
  }

  div.welcome-text{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  h4{
    font-weight: 400;
    font-size: 1.5rem;
    color: var(--white);
  }

  h1{
    width: 415px;
    font-weight: 700;
    font-size: 2.375rem;
    color: var(--white);
    text-align: center;
    margin-top: 1.3rem;
  }
`
